import React, { useEffect } from "react";
import { LoadingV2, MultiStepItemProps } from "@ucl/library";
import { useAttachUser } from "@/hooks/useAttachUser";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { useFinancialApplicationCoreData } from "@/hooks/useFinancialApplicationCoreData";
import "./UserAttachmentBufferStep.scss";

export interface UserAttachmentBufferStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const UserAttachmentBufferStep: React.FC<UserAttachmentBufferStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <UserAttachmentBufferStepInner {...props} />
    </RequireAuth>
  );
};

const UserAttachmentBufferStepInner: React.FC<UserAttachmentBufferStepProps> = ({
  financialApplicationId,
  registerSubmit,
  handleNext,
}) => {
  const { isAttached, isAttaching } = useAttachUser(financialApplicationId);
  const { coreData } = useFinancialApplicationCoreData(financialApplicationId);

  // Register a submit function that will be called when the user clicks "Continue"
  useEffect(() => {
    if (registerSubmit) {
      registerSubmit(async () => {
        // If user is attached, allow navigation to continue
        const allow = (
          isAttached &&
          coreData?.shouldRunIdvFlow !== null &&
          coreData?.shouldRunIdvFlow !== undefined);

        return allow;
      });
    }
  }, [registerSubmit, isAttached, coreData?.shouldRunIdvFlow]);

  useEffect(() => {
    // Once user attachment is complete, auto-advance to the next step
    if (
      isAttached &&
      coreData?.shouldRunIdvFlow !== null &&
      coreData?.shouldRunIdvFlow !== undefined
    ) {
      // Use the MultiStepContainer's handleNext function to advance
      handleNext?.();
    }
  }, [isAttached, handleNext, coreData?.shouldRunIdvFlow]);

  

  return (
    <div className="user-attachment-buffer-step">
      <div className="user-attachment-buffer-step__content">
        <LoadingV2 loadingType="spinner" />
        <h2>Preparing Your Application</h2>
        <p>
          {isAttaching
            ? "Attaching your account to this application..."
            : "Setting up your application..."}
        </p>
      </div>
    </div>
  );
};
